import { createSlice } from '@reduxjs/toolkit';
import { httpGet, httpPost } from '../../util/Rest';
import { DEBTOR } from '../../constants/MicroServiceConstants';
import { CREDIT_REPORTING, STATE, PHONE_TYPE, APPROVAL } from '../../constants/Lookup';
import { deleteWorkQueueByAccountNumber } from './WorkQueue';
import { SPOUSE_INFORMATION } from '../../util/Content';
import {
  clearWindowError,
  deleteModifiedWindowSessionItem,
  removeModifiedWindow,
} from './ModifiedWindows';

const initialData = {
  spouseData: {},
  dropDownData: {},
  spouseStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'spouse',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getSpouseData: (state, action) => {
      state.spouseData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postSpouseData: (state, action) => {
      state.spouseStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetSpouseStatus: (state) => {
      state.spouseStatus = null;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      // state.spouseStatus = null;
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.spouseData = {};
    },
  },
});

export default slice.reducer;

// Actions

const {
  getSpouseData,
  fetchDropDownData,
  resetMsg,
  postSpouseData,
  fetchStart,
  fetchError,
  resetSpouseStatus,
  fetchSuccess,
  resetData,
} = slice.actions;

export const getSpouse = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [CREDIT_REPORTING, STATE, PHONE_TYPE, APPROVAL],
      }),
      httpGet(`${DEBTOR}/find/spouseinfo/${accountNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const spouseData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (spouseData && spouseData.status && spouseData.status === 200) {
          dispatch(getSpouseData(spouseData.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postSpouse = ({ isDirty, ...details }) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/save/spouseinfo`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(
            deleteWorkQueueByAccountNumber({ accountNumber: details?.accountNumber, isDirty }),
          );
          dispatch(postSpouseData(data));
          dispatch(fetchSuccess(data));
          deleteModifiedWindowSessionItem(SPOUSE_INFORMATION);
          dispatch(removeModifiedWindow({ windowName: SPOUSE_INFORMATION }));
          dispatch(clearWindowError({ windowName: SPOUSE_INFORMATION }));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetSpouse = () => {
  return (dispatch) => {
    dispatch(resetSpouseStatus());
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetSpouseData = () => {
  return (dispatch) => {
    dispatch(resetData);
  };
};
